import { render, staticRenderFns } from "./income.vue?vue&type=template&id=78f69141&scoped=true&"
import script from "./income.js?vue&type=script&lang=js&"
export * from "./income.js?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=78f69141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f69141",
  null
  
)

export default component.exports